import { Injectable } from '@angular/core';
import { map, Observable, tap } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

interface IRecaptchaResponse {
  success: boolean;
}

@Injectable()
export class RecaptchaService {
  constructor(private http: HttpClient) {}

  checkToken(token: string): Observable<boolean> {
    return this.http
      .post<IRecaptchaResponse>(
        environment.recaptchaCheckURL,
        { token, remote_ip: environment.url },
        {
          headers: {
            'X-Rebuilt-Key': environment.recaptchaCheckKey,
            'Content-Type': 'application/json',
          },
        }
      )
      .pipe(
        tap((answer) => console.log('http:', answer)),
        map((answer) => answer.success)
      );
  }
}
